import { gql } from '@apollo/client';
import { CRM_AUDIENCE_FIELDS } from './queries';

export const CREATE_CRM_AUDIENCE = gql`
    mutation CreateCrmAudience($input: CreateCrmAudienceInput!) {
        createCrmAudience(input: $input) {
            ${CRM_AUDIENCE_FIELDS}
        }
    }
`;

export const UPDATE_CRM_AUDIENCE = gql`
    mutation UpdateCrmAudience($input: UpdateCrmAudienceInput!) {
        updateCrmAudience(input: $input) {
            ${CRM_AUDIENCE_FIELDS}
        }
    }
`;

export const DELETE_CRM_AUDIENCE = gql`
    mutation DeleteCrmAudience($id: String!) {
        deleteCrmAudience(id: $id) {
            _id
            name
        }
    }
`;
